import axiosInstance from '../backend/axiosInstance';

export const PlayerPhoto = {};
let fetched = false;

export async function fetchPlayerPhoto() {
  if (fetched) return;
  fetched = true;

  try {
    const response = await axiosInstance.get(
      'https://sanchidataportal.com/api4/playerphoto/');

    const data = response.data;

    data.forEach((item) => {
      PlayerPhoto[item.summonerName] = item.link;
    });
  } catch (error) {
    console.error('Błąd pobierania zjdec graczy:', error);
  }
}
